import axios from "axios";
import * as yup from "yup";
import { buildQuery } from "utils/queryUtils";

let schema = yup.object().shape({
    application: yup.string().test("not-blank", "application.required", (application) => application?.length > 0),
    profile: yup.string().test("not-blank", "profile.required", (profile) => profile?.length > 0),
    label: yup.string().test("not-blank", "label.required", (label) => label?.length > 0),
    key: yup.string().test("not-blank", "key.required", (key) => key?.length > 0),
    value: yup.string().test("not-blank", "value.required", (value) => value?.length > 0),
});

export const validateConfig = (config) => {
    return schema.validate(config, { abortEarly: false });
};

export const findConfigs = (headers, params) => {
    let query = buildQuery(params, ["application", "profile", "label", "key"]);
    return axios.get(`${process.env.REACT_APP_CONFIG_API_URL}/properties${query}`, {
        headers,
    });
};

export const findApplications = (headers) => {
    return axios.get(`${process.env.REACT_APP_CONFIG_API_URL}/properties/applications`, {
        headers,
    });
};

export const createConfig = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_CONFIG_API_URL}/properties`, data, {
        headers,
    });
};

export const updateConfig = (headers, id, data) => {
    return axios.patch(`${process.env.REACT_APP_CONFIG_API_URL}/properties/${id}`, data, {
        headers,
    });
};

export const deleteConfig = (headers, application, profile, label, key) => {
    return axios.delete(`${process.env.REACT_APP_CONFIG_API_URL}/properties/${application}/${profile}/${label}/${key}`, {
        headers: headers,
    });
};

export const reloadConfig = (headers, application) => {
    return axios.post(
        `${process.env.REACT_APP_CONFIG_API_URL}/properties/${application}/reload`,
        {},
        {
            headers,
        }
    );
};

export const encrypt = (headers, value) => {
    return axios.post(`${process.env.REACT_APP_CONFIG_API_URL}/encrypt`, value, {
        headers: { ...headers, "Content-Type": "text/plain" },
    });
};
